var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5205 38.2653C25.5205 39.0772 25.8432 39.8558 26.4175 40.4299C26.9917 41.004 27.7706 41.3265 28.5828 41.3265C29.395 41.3265 30.1739 41.004 30.7482 40.4299C31.3224 39.8558 31.6451 39.0772 31.6451 38.2653C31.6451 37.4534 31.3224 36.6748 30.7482 36.1007C30.1739 35.5266 29.395 35.2041 28.5828 35.2041C27.7706 35.2041 26.9917 35.5266 26.4175 36.1007C25.8432 36.6748 25.5205 37.4534 25.5205 38.2653V38.2653ZM26.5413 18.8776V30.6122C26.5413 30.8929 26.771 31.1224 27.0517 31.1224H30.1139C30.3946 31.1224 30.6243 30.8929 30.6243 30.6122V18.8776C30.6243 18.5969 30.3946 18.3673 30.1139 18.3673H27.0517C26.771 18.3673 26.5413 18.5969 26.5413 18.8776ZM56.8897 46.9388L30.35 1.02041C29.9544 0.33801 29.2718 0 28.5828 0C27.8938 0 27.2048 0.33801 26.8156 1.02041L0.275945 46.9388C-0.508762 48.3036 0.473716 50 2.04313 50H55.1225C56.6919 50 57.6744 48.3036 56.8897 46.9388ZM6.90448 45.1594L28.5828 7.64668L50.2611 45.1594H6.90448V45.1594Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.1ec5decc98c2ef939e50ef08546e9284.svg";
export { ForwardRef as ReactComponent };